<template>
  <!--游戏概览 数据分析-->
  <div class="fixed-page">
    <!-- 工具栏 -->
    <toolbar v-if="barData && barData.length > 0" ref="bar" :source-data="barData" @initCallback="initBarCallback" @onFilter="handleFilter" />

    <div class="app-container" :style="{'margin-top': barHeight}">
      <!-- 内容 -->
      <module-card ref="card" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Toolbar from './components/toolbar'
import ModuleCard from './components/module/moduleCard'
import { codeControl } from '@Bdc~/api/ajax_model'
import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name
export default {
  name: name,
  components: { Toolbar, ModuleCard },
  data() {
    return {
      barData: [],
      barLoading: true,
      barHeight: '', // 筛选条件高度

      currentRoute: this.$store.getters.currentRoute,
      setIntervalReload: null
    }
  },

  computed: {
    ...mapGetters(['transitionEnter'])
  },

  watch: {
    transitionEnter(val) {
      if (val == 1 && this.$refs.bar) {
        // alert('222: '+this.$refs.bar.$el.offsetHeight)
        this.$nextTick(() => {
          this.barHeight = this.$refs.bar.$el.offsetHeight + 'px'
        })
      } else {
        this.barHeight = 0
      }
    }
  },

  created() {
    this.getList()
  },

  mounted() {
    window.onresize = () => {
      // console.log('1111fixedHeight', this.$refs.bar.$el.offsetHeight)
      if (this.$refs.bar) {
        this.barHeight = this.$refs.bar.$el.offsetHeight + 'px'
      }
    }
  },

  methods: {
    // 获取工具栏（筛选项）
    getList() {
      console.log(Store.getters.currentRoute.meta.id)
      codeControl().then(response => {
        if (response.code == 1) {
          if (response.data.length > 0) {
            this.barData = JSON.parse(JSON.stringify(response.data))
          }

          this.$nextTick(() => {
            if (response.data.length > 0) {
              this.$refs['bar'].init() // 初始化
            } else {
              this.$refs['card'].getModule()
            }
          })
        }
      })
    },

    initBarCallback() {
      if (this.$refs.bar) {
        // alert('1111' + this.$refs.bar.$el.offsetHeight)
        this.barHeight = this.$refs.bar.$el.offsetHeight + 'px'
      }
    },

    // 查询
    handleFilter(val) {
      // 获取模块数据
      this.$refs['card'].getModule(val)
    }
  }
}

</script>

<style lang="scss" scoped>
.fixed-page{
  overflow: hidden;
}
  .app-container{
    background:#f9f9f9
  }
</style>
